export const BASE = 5500;
export const COMMISSION_LEVELS = [
  {
    ratio: 0.1,
    threshold: 50000
  },
  {
    ratio: 0.08,
    threshold: 20000
  },
  {
    ratio: 0.06,
    threshold: 0
  }
];
export const SALE_VOLUMES_BONUS_LEVEL = [
  {
    value: 500,
    condition: count => count >= 2000
  },
  {
    value: 200,
    condition: count => count >= 1000
  }
];
export const YEAR_END_BONUS_LEVELS = [
  {
    ratio: 0.015,
    threshold: 1000000
  },
  {
    ratio: 0.01,
    threshold: 0
  }
];

function sumWithLevels(levels, input) {
  let { sum } = levels.reduce(
    ({ sum, v }, { ratio, threshold }) => {
      if (v > threshold) {
        sum += (v - threshold) * ratio;
        v = threshold;
      }
      return { sum, v };
    },
    { sum: 0, v: input }
  );
  return sum;
}

function findWithLevels(levels, input) {
  let level = levels.find(({ condition }) => condition(input));
  if (!level) {
    return 0;
  }
  return level.value;
}

const formula = (profit, saleVolumes = []) => {
  let baseAddition =
    profit > 20000 ? Math.floor((profit - 20000) / 10000) * 100 : 0;

  let commission = sumWithLevels(COMMISSION_LEVELS, profit);

  let commissionBonus = Math.floor(profit / 100000) * 500;

  let saleVolumesBonus = saleVolumes.reduce((sum, volume) =>
    sum + findWithLevels(SALE_VOLUMES_BONUS_LEVEL, volume)
  , 0)

  let monthly =
    BASE + baseAddition + commission + commissionBonus + saleVolumesBonus;

  let yearEndBonus = BASE + sumWithLevels(YEAR_END_BONUS_LEVELS, profit * 12);

  let yearly = monthly * 12 + yearEndBonus;

  return {
    BASE,
    baseAddition,
    commission,
    commissionBonus,
    saleVolumesBonus,
    monthly,
    yearEndBonus,
    yearly
  };
};

export default formula;
